/**
 * Слова, которые повторяются на многих экранах.
 *
 * Сюда попадает только то, что и правда ОДНО И ТО ЖЕ: «Отмена» на форме
 * предмета и на форме питомца — одна кнопка, и расходиться ей нельзя. Текст,
 * который случайно совпал, живёт в своём пространстве: завтра его поправят на
 * одном экране, и общий ключ молча изменит второй.
 */
export const common = {
  action: {
    cancel: 'Отмена',
    save: 'Сохранить',
    add: 'Добавить',
    refresh: 'Обновить',
    collapse: 'Свернуть',
    showMore: 'Показать ещё',
    retry: 'Попробовать ещё раз',
    backToQueue: 'Вернуться к очереди',
  },

  field: {
    title: 'Название',
    description: 'Описание',
    kind: 'Вид',
    image: 'Изображение',
    note: 'Заметка',
    source: 'Источник',
    nickname: 'Кличка',
  },

  /** Состояния вещи: те же слова стоят и на знаке, и в фильтре. */
  state: {
    published: 'в карточке',
    pending: 'на проверке',
    archived: 'в архиве',
  },

  verdict: {
    approved: 'принято',
    rejected: 'отклонено',
  },

  /** Разделы: имена, которыми проект называет свои сущности. */
  section: {
    form: 'Анкета',
    inventory: 'Склад',
    pets: 'Питомцы',
    abilities: 'Способности',
    characters: 'Персонажи',
    members: 'Участники',
    decisions: 'Решения',
  },

  /** Пусто и не нашлось — формулировки общие у трёх экранов имущества. */
  empty: {
    noRequests: 'Заявок нет',
    emptyArchive: 'Архив пуст',
    noName: 'Без имени',
    all: 'Все',
  },

  access: {
    granted: 'запись разрешена',
    revoked: 'запись закрыта',
  },

  vkProfile: 'Профиль ВК',
  saved: 'Сохранили',
} as const;
